<section class="header">
  <nav class="navbar navbar-expand-md p-0 navbar-responsive">
    <button
      class="navbar-toggler collapsed m-2"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarCollapse"
      aria-controls="navbarCollapse"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <img src="assets/img/menu.svg" alt="menu" width="30" />
    </button>

    <div class="brand brand-name img-logo">
      <a class="navbar-brand me-auto" href="#">
        <img
          class="logo"
          src="assets/img/logo-sin-fondo.svg"
          alt="logo"
        />
      </a>
    </div>
    <div class="collapse navbar-collapse" id="navbarCollapse" #navbarCollapse>
      <ul class="navbar-nav ms-auto">
        <li class="nav-item header-nav">
          <a [routerLink]="['/inicio']" routerLinkActive="router-link-active" (click)="closeNavbar()">
            {{ "menu.home" | translate }}
          </a>
        </li>
        <li class="nav-item header-nav" >
          <a [routerLink]="['/nosotros']" routerLinkActive="router-link-active" (click)="closeNavbar()">
            {{ "menu.us" | translate }}
          </a>
        </li>
        <li class="nav-item header-nav">
          <a [routerLink]="['/servicios']" routerLinkActive="router-link-active" (click)="closeNavbar()">
            {{ "menu.services" | translate }}
          </a>
        </li>
        <li class="nav-item header-nav">
          <a [routerLink]="['/gallery']" routerLinkActive="router-link-active" (click)="closeNavbar()">
            {{ "menu.gallery" | translate }}
          </a>
        </li>
        <li class="nav-item header-nav">
          <a [routerLink]="['/contacto']" routerLinkActive="router-link-active" (click)="closeNavbar()">
            {{ "menu.contact" | translate }}
          </a>
        </li>
      </ul>
    </div>
  </nav>
</section>
